import type { ReactNode } from 'react';
import React, { useState } from 'react';
import type { Placement } from '@floating-ui/react-dom';
import useAppSelector from '../../app/redux/useAppSelector';
import Slot from '../../components/Slot';
import Tether from '../../components/Tether';
import * as styles from './TutorialBeacon.module.scss';

interface TutorialBeaconProps {
  children: ReactNode;
  id: string;
  hide?: boolean;
  placement?: Placement;
}

const TutorialBeacon = ({
  children,
  hide,
  placement = 'bottom',
  id,
}: TutorialBeaconProps) => {
  const isActive = useAppSelector(
    (state) => !!state.onboarding.activeBeacons[id],
  );
  const [anchorElement, setAnchorElement] = useState<Element | null>(null);

  return (
    <>
      <Slot ref={setAnchorElement}>{children}</Slot>
      <Tether
        anchorElement={anchorElement}
        placement={placement}
        offset={5}
        flipBehavior="disabled"
        shiftBehavior="disabled"
        portalContainer="disabled"
        strategy="fixed"
        positionedView={
          isActive &&
          !hide && (
            // Wrapper div prevents the scaling animation of dot from
            // affecting layout (`transform` property conflicting).
            <div>
              <div className={styles.dot} />
            </div>
          )
        }
      />
    </>
  );
};

export default TutorialBeacon;
